import { StockOverviewRow } from "../types/stockOverview.types";
import { ItemBasicResponse } from "../types/medicineSearch.types";
import { ItemInMarketplaceBasicResponse } from "../types/marketplaceItemSearch.types";

// Helpers for the ItemStockOverviewModal (ITAM-2613): own-row detection, stock
// normalization, and the mapping of a stock row back into the existing
// consult-order draft contract.

/** True when the row belongs to the pharmacist's own pharmacy (composite id match). */
export const isOwnPharmacyRow = (
  row: StockOverviewRow,
  marketplaceId: number,
  branchMarketplaceId: number
): boolean =>
  row.marketplaceResponse.marketplaceId === marketplaceId &&
  row.marketplaceResponse.branchMarketplaceId === branchMarketplaceId;

/** Integer stock for display and clamping (backend sends Decimal(20,4)). */
export const stockQuantity = (row: StockOverviewRow): number =>
  Math.max(0, Math.floor(row.itemQuantity));

/**
 * Map the own-pharmacy stock row into the existing draft contract so the whole
 * downstream pipeline (context, list, payload) stays unchanged. `selected` is
 * the genuine ItemBasicResponse the pharmacist picked in the dropdown — reused
 * verbatim as basicInfo (images for OrderItemsList thumbnails, etc.).
 */
export const toDraftItem = (
  row: StockOverviewRow,
  selected: ItemBasicResponse
): ItemInMarketplaceBasicResponse => ({
  id: {
    itemId: selected.id,
    marketplaceId: {
      marketplaceId: row.marketplaceResponse.marketplaceId,
      branchMarketplaceId: row.marketplaceResponse.branchMarketplaceId,
    },
  },
  name: selected.name,
  lowestPrice: row.itemLowestPrice,
  price: row.itemPrice,
  priceWithDiscount: row.itemPriceWithDiscount,
  quantity: stockQuantity(row),
  fromOutlet: row.outletMarket,
  discount: row.discount,
  itemExternalName: row.itemExternalName,
  basicInfo: selected,
});
